/* eslint-disable no-unused-vars */
/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-09-21 10:00:32
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2022-08-11 15:01:23
 */

import Modal from './Modal';
import confirm, {
  pause as pauseConfirm,
  start as startConfirm,
  remove as removeConfirm,
} from './confirm';
// import pop, {
//   pause as pausePop,
//   start as startPop,
//   remove as removePop,
// } from './pop';
import alert from './alert';
import { destroyModal, getModalSequenceLength } from './modalSequences';
import './style.less';

Modal.confirm = confirm;
Modal.pause = () => {
  pauseConfirm();
  // pausePop();
};
Modal.start = () => {
  startConfirm();
  // startPop();
};
// Modal.pop = pop;
Modal.alert = alert;
Modal.close = (sequenceId, alwayDestroy = true) => {
  destroyModal(sequenceId, alwayDestroy);
};

Modal.remove = (sequenceId) => {
  removeConfirm(sequenceId);
  // removePop(sequenceId);
};

Modal.getLength = () => {
  return getModalSequenceLength();
};

export default Modal;
